import { useState } from "react";
import { useAuthHeader, useAuthUser } from "../../../../Services/Auth/sessionAuth";
import { Button, Form,  Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Typography } from '@mui/material';
import { Crypter } from "../../../../Functions/Security/Crypter";
import Data from '../../../../Data/Data.json';
import axios from "axios";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import { ParamsMourabaha, ParamsMourabahaCompteGl } from "../../../../Models/ParamsMourabahaDto";

const TypeFinancementMourabaha = () => {

    const auth = useAuthUser();
    const authHeader = useAuthHeader();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
    const [paramsMourabahaCompteGl,setParamsMourabahaCompteGl]=useState<ParamsMourabahaCompteGl[]>([]);
    const [Activetabs, SetActivetabs] = useState(false);

    // Handle function
    function HandleConsult() {
        setConsulte(false);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false);
        SetActivetabs(true)
    }

    function HandleAjout() {
        form.resetFields();
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSearchGlobal(true);
        setSbmit('add');
    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false)
        setFormactve(false);
        setSbmit('modif')
        setSupprime(true)
        SetActivetabs(false)
        setSearchGlobal(true);
    }

    function HandleSupp() {
        setSbmit('supp')
    }

    function HandleAnnul() {
        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setParamsMourabahaCompteGl([]);
        setFormactve(true);
        setSbmit('');
        SetActivetabs(false);
       setSearchGlobal(false);
    }


    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Type de financement
                </span>
            ),
            children: <Tab1 etatG={SearchGlobal} form={form}/>
               
        },
        {
            key: '2',
            label: (
                <span id='x2'>
                    <ContactsOutlined />
                    Interface comptes
                </span>
            ),
            children:<Tab2 etatG={SearchGlobal} form={form} glRows={paramsMourabahaCompteGl}  setGlRows={setParamsMourabahaCompteGl}/> 
        },
         {
            key: '3',
            label: (
                <span id='3'>
                    <UserOutlined />
                      Autorisations
                </span>
            ),
            children: <Tab3 form={form} /> 
        }
        
    ];

    // function consult 
    function consult()
     {
        if (form.getFieldValue("CodeMourabaha") == null) 
        {
            SweetAlert.fire({ title: "Svp renseigner le Code du type de Qard ", icon: "warning" });
        } else 
        {
            let data = Crypter.encrypt((form.getFieldValue("CodeMourabaha")));
           
            if (data.length != 0) 
            {
                setLoading(true);

                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadParamsMourabaha,
                    headers: {
                        'CypherCodeMourabaha': data,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => 
                     {
                        setLoading(false);
                        if (response.data) 
                        {
                            //const res = JSON.parse(Crypter.decrypt(response.data));
                            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                            // console.log(DemandVP);

                            if (res.StatutCode == 200) 
                            {
                                 let  ParamsMourabaha : ParamsMourabaha = res.Result.Table1[0];
                                 ParamsMourabaha.CategorieActifsMourabaha=res.Result.Table2.map((x: any) => x.CodeCategorie);
                                 ParamsMourabaha.Frais=res.Result.Table3.map((x: any) => x.CODOPE);
                                 ParamsMourabaha.ComptesRemboursementAuto=res.Result.Table4.map((x: any) => x.IDPLAN);
                              // ParamsMourabaha.Planfours=res.Result.Table5.map((x: any) => x.IDPLAN);
                                 ParamsMourabaha.TypeGarantieAuto=res.Result.Table5.map((x: any) => x.CodeTypeGarantie);
                                 const paramsMourabahaCompteGl: ParamsMourabahaCompteGl[] =
                                    res.Result.Table6.map((x: ParamsMourabahaCompteGl,y: number) => ({
                                        Id: y,
                                        CodeAgence: x.CodeAgence,
                                        CompteProfitDiffere: x.CompteProfitDiffere,
                                        CompteProfitReel: x.CompteProfitReel,
                                        CompteStockMourabaha: x.CompteStockMourabaha,
                                        ComptePromesseOctroi: x.ComptePromesseOctroi,
                                        CompteCharity: x.CompteCharity,
                                        CompteTvaDifferee: x.CompteTvaDifferee,
                                        CompteTvaCollecte: x.CompteTvaCollecte
                                    }));

                                  setParamsMourabahaCompteGl(paramsMourabahaCompteGl);
                                     
                                 form.setFieldsValue(ParamsMourabaha);
                                 HandleConsult();
                                
                                //  console.log(ParamsQard);
                            }
                            else
                           {
                                SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => 
                    {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }

    // function Onfinish
    const onFinish = () => 
     {
        const values = form.getFieldsValue(true);
        //console.log(values)
        var ParamsMourabaha: ParamsMourabaha = values;
            ParamsMourabaha.CODUTI =user.coduti;
            ParamsMourabaha.CodAge = user.codage;
            ParamsMourabaha.ParamsMourabahaCompteGl=paramsMourabahaCompteGl;

            // alert(JSON.stringify(ParamsMourabaha.TauxFondGarantie));

            if (sbmit == "add" ) 
            {
                SweetAlert.fire({
                    title: "Création du Paramètre de financement Mourabaha",
                    text: "Voulez-vous Créer le Paramètre de financement Mourabaha " + ParamsMourabaha.LibelleMourabaha + " ?" ,
                    showCancelButton: true,
                    color: "green",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "green",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: "question"
                }).then((res) => 
                {
                    if (res.isConfirmed) 
                    {
                        setLoading(true);
                        setIsSubmit(true);
                        //console.log(JSON.stringify(DemandVP));

                        let data = Crypter.encrypt(JSON.stringify(ParamsMourabaha));
                        let config = 
                        {
                            method: 'post',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.CreateParamsMourabaha,
                            headers: 
                            {
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                            data: data
                        };
                        axios.request(config)
                            .then((response) => 
                              {
                                setLoading(false);
                                if (response.data) 
                                 {
                                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                                   
                                    if (res.StatutCode == 200) 
                                    { 
                                       SweetAlert.fire({ title: res.Message, text: res.Result , icon: "success" });
                                        HandleAnnul();
                                    }
                                    else 
                                    {
                                        SweetAlert.fire({ title:  res.Message, text: res.Result, icon: "warning" })
                                    }
                                }
                            })
                            .catch((error) => 
                            {
                                setLoading(false);
                                console.log(error)
                                SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                            });
                    }
                })
            }
            // ********************************************************************************************************************************
            if (sbmit == "modif") 
            {
                SweetAlert.fire({
                    title: "Mise à jour du Paramètre de financement Mourabaha",
                    text: "Voulez-vous mettre à jour le Paramètre de financement Mourabaha "  + ParamsMourabaha.CodeMourabaha,
                    showCancelButton: true,
                    color: "green",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "green",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: "question"
                }).then((res) => 
                {
                    if (res.isConfirmed) 
                    {
                        setLoading(true);
                        setIsSubmit(true)
                        //console.log(JSON.stringify(DemandVP));

                        let data = Crypter.encrypt(JSON.stringify(ParamsMourabaha));
                        let config = 
                        {
                            method: 'put',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.UpdateParamsMourabaha,
                            headers: {
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                            data: data
                        };
                        axios.request(config)
                         .then((response) => 
                            {
                                setLoading(false);
                                if (response.data) 
                                {
                                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                                    // alert(JSON.stringify(res))
                                    console.log(res)
                                    if (res.StatutCode == 200) 
                                    { 
                                            SweetAlert.fire({ title: res.Message, text: res.Result , icon: "success" });
                                            HandleAnnul();
                                    }
                                    else 
                                    {
                                        SweetAlert.fire({ title: "Warning", text: res.Result, icon: "warning" })
                                    }
                                }
                            })
                            .catch((error) => 
                            {
                                setLoading(false);
                                console.log(error);
                                SweetAlert.fire({ title: "Error Front", text: error, icon: "error" });
                            });
                    }
                })
        } 
    }

    // function de verification 
    const onFinishFailed = async (errorInfo: any) => 
    {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => 
        {
            errors.push(error.name + "");
        })
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => 
    {
        if (!isSubmit) 
        {
            Swal.fire({ title: "Attention", text: "Veuillez remplir tous les champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form preserve={true} disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult() }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>
                                    Désactiver 
                                </Button>
                                {/* <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button> */}
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card"  items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default TypeFinancementMourabaha;